import React from "react"
import { Skeleton } from "@material-ui/lab"
import { Grid, Card } from "@material-ui/core"
import useStyles from "@/@integrations/WABA/components/WabaAccountInfo/styles"

const WABAAccountInfoSkeleton = () => {
	const classes = useStyles()

	return (
		<Grid container spacing={2}>
			{Array.from({ length: 3 }).map((_, i) => (
				<Grid item xs={12} sm={4} key={i}>
					<Card className={classes.card}>
						<Grid container direction="column" spacing={1}>
							<Grid item>
								<Skeleton variant="text" width="60%" height={32} />
							</Grid>
							<Grid item>
								<Skeleton variant="text" width="40%" height={20} />
							</Grid>
						</Grid>
					</Card>
				</Grid>
			))}
			<Grid item xs={12} className={classes.tableContainer}>
				<Skeleton variant="text" width="200px" height={32} />
				<Skeleton variant="rect" width="100%" height={600} />
			</Grid>
		</Grid>
	)
}

export default WABAAccountInfoSkeleton
